var BOLD_Loaded = false;


document.addEventListener("DOMContentLoaded", function(){

  BOLD.common.eventEmitter.on("BOLD_COMMON_cart_prices_updated", function(){
    if(BOLD_Loaded)return;
    BOLD_Loaded = true;

   if (BOLDCURRENCY.currentCountryCode === 'CA' || BOLDCURRENCY.currentCountryCode === 'US'  ){
     
      var style = document.createElement("style")
      style.innerText = ".shopify-payment-button__button{display:none!important;}"
      document.documentElement.append(style);
      
    }
  });
});



document.addEventListener('DOMContentLoaded', function(){
  
   setInterval(function(){
       BOLDCURRENCY.currencyCookie.write(BOLDCURRENCY.currentCurrency);
   }, 600000);
});